import { ComponentProps, forwardRef, useState, ReactNode } from "react";
import { cn } from "@/lib/utils";

export type ImageProps = ComponentProps<"img"> & {
  src: string;
  alt?: string;
  className?: string;
  loadingFallback?: ReactNode;
  errorFallback?: ReactNode;
  testId?: string;
  loading?: "eager" | "lazy";
};

export const Image = forwardRef<HTMLImageElement, ImageProps>(
  (
    {
      src = "",
      alt,
      className = "",
      loadingFallback,
      errorFallback,
      testId,
      loading,
      ...props
    },
    ref,
  ) => {
    const [error, setError] = useState(false);

    return error ? (
      errorFallback || <div className="tw-size-full tw-bg-gray-300" />
    ) : (
      <img
        loading={loading}
        data-testid={testId}
        ref={ref}
        className={cn(
          "tw-w-full tw-h-full tw-object-cover tw-object-center",
          className,
        )}
        src={src}
        alt={alt}
        onError={() => {
          setError(true);
        }}
        {...props}
      />
    );
  },
);
Image.displayName = "Image";
